// Estimates how many candidates a bulk AI summary run will actually process.
// Candidates whose AiJobApplicationSummaryStatus is "current" already have a
// succeeded, non-stale summary and are excluded at enqueue, so they are not
// processed and should not be counted.
//
// `isExact` is true when every selected candidate is loaded on the client
// (always the case for an "included" selection, since only loaded rows can be
// checked; for "excluded"/Select-All it holds only once the whole stage is
// loaded). When false, the count is an upper bound: unloaded candidates whose
// status we cannot see may also be "current".

interface BulkSummaryCountArgs {
  jobApplications: Array<any>;
  itemIdsSet: Set<number>;
  itemIdsSetType: "included" | "excluded";
  selectionCount: number;
  selectableCount: number;
}

interface BulkSummaryCount {
  count: number;
  isExact: boolean;
}

export function bulkSummaryProcessableCount({
  jobApplications,
  itemIdsSet,
  itemIdsSetType,
  selectionCount,
  selectableCount,
}: BulkSummaryCountArgs): BulkSummaryCount {
  const isSelected = (jobApplication: any) =>
    itemIdsSetType === "included"
      ? itemIdsSet.has(jobApplication.id)
      : !itemIdsSet.has(jobApplication.id);

  const loadedCurrentSelected = jobApplications.filter(
    (jobApplication) =>
      isSelected(jobApplication) &&
      jobApplication.aiJobApplicationSummaryStatus?.status === "current",
  ).length;

  const isExact = itemIdsSetType === "included" || jobApplications.length >= selectableCount;

  return {
    count: Math.max(0, selectionCount - loadedCurrentSelected),
    isExact,
  };
}
